import { GetCompanyListRequest } from '@trukt/tms-api/CompanyServices';
import { createKey } from './createKey';

const keyHandler = createKey('company');

export const CompanyServiceKeys = {
  key: keyHandler.key,
  search: keyHandler.createMethod(),
  getList: keyHandler.createMethod<GetCompanyListRequest>(),
};
